import React from "react";
import { BsFileWord, BsTable, BsFilePdf } from "react-icons/bs";

export default function FiltersSortCard({
    t,
    formData,
    exportFormats,
    handleFilterChange,
    handleExportFormatChange,
    getIncludeFieldsState,
    toggleAllIncludeFields,
    toggleIncludeField,
    getSearchFieldsState,
    toggleAllSearchFields,
    toggleSearchField,
    updateSortOrder
}) {
    return (
        <div className="card filters-sort-card">
            <div className="card-header">
                <h3>{t("admin.filters_and_sort")}</h3>
            </div>
            <div className="card-body">
                <div className="filters-sort-combined">
                    {/* Filter Checkboxes */}
                    <div className="form-group">
                        <div className="filters-group">
                            <label className="checkbox-group">
                                <input
                                    type="checkbox"
                                    checked={formData.isTransactionReport}
                                    onChange={() =>
                                        handleFilterChange("isTransactionReport")
                                    }
                                />
                                {t("admin.transaction_report")}
                            </label>
                            <label className="checkbox-group">
                                <input
                                    type="checkbox"
                                    checked={formData.enableDateRange}
                                    onChange={() => handleFilterChange("enableDateRange")}
                                />
                                {t("admin.enable_date_range")}
                            </label>
                        </div>
                    </div>

                    {/* Export Options - horizontal line with compact spacing */}
                    <div className="form-group export-options-group">
                        <label>{t("admin.export_options")}</label>
                        <div className="export-options">
                            {[
                                {
                                    key: "word",
                                    label: "Word",
                                    icon: <BsFileWord size={14} color="#2b579a" />,
                                },
                                {
                                    key: "table",
                                    label: "Table",
                                    icon: <BsTable size={14} color="#6c757d" />,
                                },
                                {
                                    key: "pdf",
                                    label: "PDF",
                                    icon: <BsFilePdf size={14} color="#e74c3c" />,
                                },
                            ].map(({ key, label, icon }) => (
                                <label key={key} className="export-format">
                                    <input
                                        type="checkbox"
                                        checked={exportFormats[key]}
                                        onChange={() => handleExportFormatChange(key)}
                                    />
                                    {icon}
                                    <span>{t(`admin.export_${key}`)}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    {/* Include Properties */}
                    <div className="property-card">
                        <div
                            className="property-header"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: "10px",
                            }}
                        >
                            <h5 style={{ margin: 0 }}>
                                {t("admin.include_properties")}
                            </h5>
                            <label
                                className="select-all-checkbox"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "12px",
                                    cursor: "pointer",
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={getIncludeFieldsState() === "all"}
                                    ref={(input) => {
                                        if (input) {
                                            input.indeterminate =
                                                getIncludeFieldsState() === "partial";
                                        }
                                    }}
                                    onChange={toggleAllIncludeFields}
                                    style={{ marginRight: "5px" }}
                                />
                                {getIncludeFieldsState() === "all"
                                    ? t("admin.deselect_all")
                                    : t("admin.select_all")}
                            </label>
                        </div>
                        <div className="properties-list">
                            <div className="properties-list-content">
                                {formData.includeFields.map((field, index) => (
                                    <div key={index} className="properties-item">
                                        <input
                                            type="checkbox"
                                            id={`include-${index}`}
                                            checked={!field.excluded}
                                            onChange={() => toggleIncludeField(index)}
                                        />
                                        <label
                                            htmlFor={`include-${index}`}
                                            className="truncate"
                                        >
                                            {field.name}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Search Properties */}
                    <div className="property-card">
                        <div
                            className="property-header"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: "10px",
                            }}
                        >
                            <h5 style={{ margin: 0 }}>
                                {t("admin.search_properties")}
                            </h5>
                            <label
                                className="select-all-checkbox"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "12px",
                                    cursor: "pointer",
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={getSearchFieldsState() === "all"}
                                    ref={(input) => {
                                        if (input) {
                                            input.indeterminate =
                                                getSearchFieldsState() === "partial";
                                        }
                                    }}
                                    onChange={toggleAllSearchFields}
                                    style={{ marginRight: "5px" }}
                                />
                                {getSearchFieldsState() === "all"
                                    ? t("admin.deselect_all")
                                    : t("admin.select_all")}
                            </label>
                        </div>
                        <div className="properties-list">
                            <div className="properties-list-content">
                                {formData.searchFields.map((field, index) => (
                                    <div key={index} className="properties-item">
                                        <input
                                            type="checkbox"
                                            id={`search-${index}`}
                                            checked={!field.excluded}
                                            onChange={() => toggleSearchField(index)}
                                        />
                                        <label
                                            htmlFor={`search-${index}`}
                                            className="truncate"
                                        >
                                            {field.name}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Sort Order */}
                    <div className="sort-container">
                        <h5>{t("admin.sort_order")}</h5>
                        {formData.sortFields.map((field, index) => (
                            <div key={index} className="sort-item">
                                <div className="sort-item-label truncate">
                                    {field.name}
                                </div>
                                <div className="sort-options">
                                    <label className="radio-group">
                                        <input
                                            type="radio"
                                            name={`sort-${index}`}
                                            checked={field.order === "ASC"}
                                            onChange={() => updateSortOrder(index, "ASC")}
                                        />
                                        {t("components.reportPage.sort_labels.asc")}
                                    </label>
                                    <label className="radio-group">
                                        <input
                                            type="radio"
                                            name={`sort-${index}`}
                                            checked={field.order === "DESC"}
                                            onChange={() => updateSortOrder(index, "DESC")}
                                        />
                                        {t("components.reportPage.sort_labels.desc")}
                                    </label>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
